import React from 'react'
import { GroupStatusType } from '../../../../typings'
import { GROUP_STATUS } from '../../../constants'
import { SmallerHeaderContent } from './SmallerHeaderContent'
import { BigHeaderContent } from './BigHeaderContent'

interface HeaderGroupDetailProps {
  isSmallerScreen: boolean
  groupDescription: string
  groupName: string
  formattedCreatorInfo: any
  isEditEnabled?: boolean
  status: GroupStatusType
  handleClickOnEdit: () => void
}

const HeaderGroupDetail: React.FC<HeaderGroupDetailProps> = (props) => {
  const {
    isSmallerScreen,
    groupDescription,
    groupName,
    formattedCreatorInfo,
    isEditEnabled,
    status,
    handleClickOnEdit,
  } = props

  const isClosed = status === GROUP_STATUS.CLOSED

  return (
    <>
      {isSmallerScreen ? (
        <SmallerHeaderContent
          groupName={groupName}
          groupDescription={groupDescription}
          handleClickOnEdit={handleClickOnEdit}
          isClosed={isClosed}
          isEditEnabled={isEditEnabled}
        />
      ) : (
        <BigHeaderContent
          groupName={groupName}
          groupDescription={groupDescription}
          formattedCreatorInfo={formattedCreatorInfo}
          isClosed={isClosed}
        />
      )}
    </>
  )
}

export default HeaderGroupDetail
